<template>
    <div class="loading" >
      <div class="lds-dual-ring"></div>
      <p class="loading-text">Загрузка...</p>
    </div>
    
  </template>
  
  <script>
  export default {
    name:'mini-loader',  
  };
  </script>
  
  <style scoped>
  .loading {
    display: flex;
    align-items: center;    
    max-height: 20px;
  }
  
  .loading-text {
    font-size: 12px;
    margin-left: 10px;
  }
  
  .lds-dual-ring {
    display: inline-block;
  }
  .lds-dual-ring:after {
    content: " ";
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 4px solid #3498db;
    border-color: #3498db transparent #3498db transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }
  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
  </style>
  